<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <div class="text-center">
            <h4>Consulta de Afiliados</h4>
            <span class="text-center" style="font-weight: 400; font-size: small;">
              Ingresa los datos y realiza tu busqueda
            </span>
          </div>
          <hr class="horizontal dark" />
          <div class="row pl-2 pr-2">
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <label class="form-control-label">Documento de Identidad <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="documentoIdentidad">
            </div>
            <div class="col-md-3">
              <button
                class="btn btn-addiuva-dark w-100"
                style="margin-top: 30px;"
                @click="searchAfiliados"
                :disabled="!documentoIdentidad"
                title="Consultar"
              >
                <i class="fas fa-search pr-1"></i> Consultar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 p-3" v-if="device.isMobile">
        <div v-for="afiliado in afiliaciones" :key="afiliado.idAfiliado">
          <div class="card p-3 text-center mb-4 shadow">
            <div class="mb-0" style="font-size: 24px;">{{ afiliado.nombres + ' ' + afiliado.apellidos }}</div>
            <p><i class="fas fa-address-card text-addiuva text-sm opacity-10"></i> {{ afiliado.documentoIdentidad }}</p>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-xs-6 col-6">
                <div class="card bg-gradient-gray text-center p-2">
                  <label style="font-size: 12px; font-weight: 400; margin: 0px;">Cobertura</label>
                  <div class="text-addiuva" style="font-size: 14px; font-weight: 600;">{{ afiliado.tipoCobertura }}</div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-xs-6 col-6">
                <div class="card bg-gradient-gray text-center p-2">
                  <label style="font-size: 12px; font-weight: 400; margin: 0px;">Valor Cobertura</label>
                  <div class="text-addiuva" style="font-size: 14px; font-weight: 600;">{{ afiliado.valorCobertura }} %</div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-xs-12 col-12 mt-2">
                <div class="text-center">
                  <label style="font-size: 12px; font-weight: 400; margin: 0px;">Total Importe Máximo</label>
                  <span class="text-addiuva" style="font-size: 14px; font-weight: 600;"> Bs. {{ afiliado.totalImporteMaximo }}</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-xs-12 col-12 mt-2">
                <div class="card bg-gradient-addiuva text-center p-2">
                  <label style="color: #FFF; font-size: 12px; font-weight: 400; margin: 0px;">Saldo Actual</label>
                  <div style="color: #FFF; font-size: 24px; font-weight: 800;">Bs. {{ afiliado.importeMaximo }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="afiliaciones.length == 0">
          <div class="text-gray text-center">No hay resultados que mostrar. </div>
        </div>
      </div>
      <div class="col-lg-12 bg-white border-radius-xl p-3" v-if="device.isMobile == false">
        <div class="row p-2">
          <Toast />
          <DataTable :value="afiliaciones" ref="dtAfiliaciones" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <div class="text-gray text-center">No hay resultados que mostrar. </div></template>
            <Column field="idAfiliado" header="ID Afiliado" sortable></Column>
            <Column field="documentoIdentidad" header="Doc. Identidad" sortable></Column>
            <Column field="nombres" header="Nombres" sortable></Column>
            <Column field="apellidos" header="Apellidos" sortable></Column>
            <Column field="tipoCobertura" header="Tipo Cobertura" sortable></Column>
            <Column field="valorCobertura" header="Valor Cobertura" sortable></Column>
            <Column field="importeMaximo" header="Importe Máximo" sortable></Column>
            <Column field="totalImporteMaximo" header="Total Importe Máximo" sortable></Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="afiliaciones.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
import {useDevice} from '../services/useDevice';

export default {
  name: "consulta-afiliados",
  components: {
    DataTable,
    Column,
    Toast
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      documentoIdentidad: null,
      afiliaciones: [],
      device: useDevice(),
    };
  },
  methods: {
    searchAfiliados() {
      this.afiliaciones = [];
      let payload = {
        "idAfiliado": "",
        "documentoIdentidad": this.documentoIdentidad ?? '',
        "sucursal": "Addiuva Center",
        "departamento": ""
      }
      // Send Data by Axios
      let url = this.API_URL + "/consulta_afiliado";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let afiliaciones = [];
            data.forEach(a => {
              afiliaciones.push({
                idAfiliado: a.idAfiliado,
                nombres: a.nombres,
                apellidos: a.apellidos,
                valorCobertura: a.valorCobertura,
                importeMaximo: a.importeMaximo,
                totalImporteMaximo: a.totalImporteMaximo,
                tipoCobertura: a.tipoCobertura,
                documentoIdentidad: a.documentoIdentidad,
              });
            });
            afiliaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.afiliaciones = afiliaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    },
    exportCSV() {
      this.$refs.dtAfiliaciones.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
  }
};
</script>
<style>
  .p-splitbutton-defaultbutton{
    display: none !important;
  }
  .p-button-icon-only {
    border-radius: 50px !important;
  }
  .bg-gradient-addiuva {
    /* background: linear-gradient(310deg, #8B46CD 0%, #E75CE0 50%, #FFCC6D 100%); */
    background: linear-gradient(310deg, #8B46CD 0% 33%, #E75CE0 33% 66%, #FFCC6D 66% 100%);
  }
  .bg-gradient-gray {
    background: linear-gradient(310deg, #e9e9e9, #dfd0ed);
  }
</style>